module.exports = __webpack_public_path__ + "static/media/arrowRightGreen.ee86d4aa.svg";